import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { backend } from '@shared/datastore/core';
import { milestoneRequestsBackend } from './milestone-requests.backend';
// import { DatastoreBackendModule } from '@shared/datastore/core';
import { milestoneRequestsReducer } from './milestone-requests.reducer';

// FIXME: remove that
backend.milestoneRequests = milestoneRequestsBackend;

@NgModule({
  imports: [
    StoreModule.forFeature('milestoneRequests', milestoneRequestsReducer),
    /* DatastoreBackendModule.forFeature(
      'milestoneRequests',
      milestoneRequestsBackend,
    ),*/
  ],
})
export class DatastoreMilestoneRequestsModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/milestone-requests/milestone-requests.module.ts